import { Component, Input } from "@angular/core";
import { FormTemplateQuestion } from "src/app/main/model/forms/form-template-question.model";
import { QuestionNPS } from "src/app/main/model/forms/question-NPS.model";
import { QuestionDate } from "src/app/main/model/forms/question-date.model";
import { QuestionList } from "src/app/main/model/forms/question-list.model";
import { QuestionNumeric } from "src/app/main/model/forms/question-numeric.model";
import { QuestionRange } from "src/app/main/model/forms/question-range.model";
import { QuestionRank } from "src/app/main/model/forms/question-rank.model";
import { QuestionText } from "src/app/main/model/forms/question-text.model";

@Component({
  template: "",
  standalone: false,
})
export class FormTemplateQuestionBaseComponent {
  @Input() public formTemplateQuestion: FormTemplateQuestion;

  public isQuestionRange(question: FormTemplateQuestion): question is QuestionRange {
    return FormTemplateQuestion.isQuestionRange(question);
  }
  public isQuestionList(question: FormTemplateQuestion): question is QuestionList {
    return FormTemplateQuestion.isQuestionList(question);
  }
  public isQuestionRank(question: FormTemplateQuestion): question is QuestionRank {
    return FormTemplateQuestion.isQuestionRank(question);
  }
  public isQuestionText(question: FormTemplateQuestion): question is QuestionText {
    return FormTemplateQuestion.isQuestionText(question);
  }
  public isQuestionDate(question: FormTemplateQuestion): question is QuestionDate {
    return FormTemplateQuestion.isQuestionDate(question);
  }
  public isQuestionNumeric(question: FormTemplateQuestion): question is QuestionNumeric {
    return FormTemplateQuestion.isQuestionNumeric(question);
  }
  public isQuestionNPS(question: FormTemplateQuestion): question is QuestionNPS {
    return FormTemplateQuestion.isQuestionNPS(question);
  }
}
